import type {IHolidayFormData} from "../types/holidays.types";
import type {Holiday, DayOfWeek} from "../../../domains/models/holiday";

export function modelMapper(data: IHolidayFormData): Holiday {
    return {
        id: data?.id,
        name: data.name,
        type: data.type,
        day: data.date.format("dddd").toUpperCase() as DayOfWeek,
        date: data.date.utc(true).toDate(),
        year: String(data.date.toDate().getFullYear()),
        notify: data.notify ?? true,
    }
}
